/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { DeleteConversationMutationResponse, DeleteConversationPathParams, DeleteConversation401, DeleteConversation500 } from "../../types/chatController/DeleteConversation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteConversation } from "../../client/chatController/deleteConversation.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteConversationMutationKey = () => [{ url: '/api/organizations/:organizationId/chat/conversations/:conversationId' }] as const

export type DeleteConversationMutationKey = ReturnType<typeof deleteConversationMutationKey>

export function deleteConversationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteConversationMutationKey()
        return mutationOptions<DeleteConversationMutationResponse, ResponseErrorConfig<DeleteConversation401 | DeleteConversation500>, {organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, conversationId }) => {
            return deleteConversation(organizationId, conversationId, config)
          },
        })

}

/**
 * @summary Archive (soft-delete) a conversation
 * {@link /api/organizations/:organizationId/chat/conversations/:conversationId}
 */
export function useDeleteConversation<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteConversationMutationResponse, ResponseErrorConfig<DeleteConversation401 | DeleteConversation500>, {organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteConversationMutationKey()

          const baseOptions = deleteConversationMutationOptions(config) as UseMutationOptions<DeleteConversationMutationResponse, ResponseErrorConfig<DeleteConversation401 | DeleteConversation500>, {organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"]}, TContext>
          

          return useMutation<DeleteConversationMutationResponse, ResponseErrorConfig<DeleteConversation401 | DeleteConversation500>, {organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteConversationMutationResponse, ResponseErrorConfig<DeleteConversation401 | DeleteConversation500>, {organizationId: DeleteConversationPathParams["organizationId"], conversationId: DeleteConversationPathParams["conversationId"]}, TContext>
      
}